import React, { FC, useEffect } from "react";
import Loader from "Loader/Main";
import { useDispatch } from "react-redux";
import { setLocation, signout } from "store/actions/auth.actions";
import useAuthenticate from '../../hooks/useAuthenticate'

const Logout: FC = () => {
  const dispatch = useDispatch();
  const { logout, isAuthenticated, accounts, inProgress } = useAuthenticate()

  useEffect(() => {
    if (inProgress) return;
    if (accounts.length > 0 && isAuthenticated) {
      dispatch(signout());
      logout()
    } else {
      dispatch(setLocation("/login"));
    }
  }, [dispatch, isAuthenticated, accounts, inProgress, logout]);
  return <Loader />;
};

export default Logout;
